import { createSelector } from 'reselect';
import { get } from 'lodash';

import { getIndexViewPixel } from '@sparefoot/react-core/utils/tracking';

export default createSelector(
	(state) => state.pages.home,
	(home) => ({
		meta: get(home, 'meta', {}),
		featuredCities: get(home, 'featuredCities', []),
		trackingPixel: getIndexViewPixel()
	})
);
